import { useLocation } from "react-router-dom";
import { RouteType } from "shared/routes/types";
import { useDynamicRouting } from "./useDynamicRouting";

export const useRoutingDataByPathname = (): RouteType => {
  const location = useLocation();
  const currentPath = location.pathname;
  const { dynamicRoutes } = useDynamicRouting();

  const routes = Object.values(dynamicRoutes);

  return (
    routes.find((routeData) => {
      if (routeData.elements) {
        const matchedElement = routeData.elements.find((element) =>
          currentPath.includes(element.pathname),
        );

        if (matchedElement) {
          return {
            ...matchedElement,
            algoliaIndexName: routeData.nestedRoute?.algoliaIndexName,
          };
        }
      }

      return routeData.pathname === currentPath;
    }) ?? ({} as RouteType)
  );
};
